import script from "./BaseInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=dd50006e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd50006e"]])

export default __exports__